// House system selection. Placidus is the default (it is what most people
// see on astro.com and in most apps); it is undefined near the poles, where
// we fall back to Porphyry and say so. Whole Sign is always available.

import { placidusCusps, porphyryCusps, wholeSignCusps } from "./core.js";

export const HOUSE_SYSTEMS = {
  placidus: "Placidus",
  "whole-sign": "Whole Sign",
  porphyry: "Porphyry",
};

export function computeCusps(system, ang, lat) {
  if (system === "whole-sign") return { system, cusps: wholeSignCusps(ang.asc) };
  if (system === "porphyry") return { system, cusps: porphyryCusps(ang.asc, ang.mc) };
  const p = placidusCusps(ang.ramc, lat, ang.eps, ang.asc, ang.mc);
  if (p) return { system: "placidus", cusps: p };
  return { system: "porphyry", cusps: porphyryCusps(ang.asc, ang.mc), fallback: true };
}
